import {authorized} from "./ApiClient";
import {send} from "./http";
import {fromCatalog} from "./catalog";
import {SiteConfig, SiteConfigSwitches} from "./models";

// The site's switches, maintenance mode and the shop, and the shop's closed notice.
export const SiteConfigApi = {
    // Anyone, even in maintenance mode: it's how the site knows to show its maintenance message. From the catalog on
    // the CDN (catalog.ts), or the API when that can't be had.
    get: () => fromCatalog(x => x.siteConfig, () => send<SiteConfig>('GET', '/site-config')),

    // Sets each setting given (SiteAdmin). Maintenance mode: only administrators can use the site. The shop closed: no
    // checkout starts, but payments already under way still complete. The closed message: what the home page says then.
    set: (switches: SiteConfigSwitches) => authorized<SiteConfig>('PUT', '/site-config', switches)
};
